// extracted by mini-css-extract-plugin
export default {"button":"Button_button__Y+F0s","red":"Button_red__mPjRr","orange":"Button_orange__VEVci","disabled":"Button_disabled__hk3n+","text":"Button_text__7qj6O"};